import script from "./BaseHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseHeader.vue?vue&type=script&setup=true&lang=js"

import "./BaseHeader.vue?vue&type=style&index=0&id=03e92c6d&lang=css"

const __exports__ = script;

export default __exports__